module.exports = __webpack_public_path__ + "4d4a632574b08321de2f48c46c150b3d.svg";